import React from 'react';
import useConfirmOnTabClose from '@src/hooks/useConfirmOnTabClose';
import { DASHBOARD_TYPE } from '@utils/constants';

function useConfirmUtil({ dashboard, isActive }) {
  // only viewer dashboards requires this check
  const enabled =
    isActive &&
    [DASHBOARD_TYPE.TIMELINE, DASHBOARD_TYPE.VIEWER_MODULE].includes(dashboard.type) &&
    dashboard.isSaved &&
    dashboard.hasChanged;
  useConfirmOnTabClose({ enabled });
}

export default useConfirmUtil;
